import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/kindle-settings-desktop.png'
import _imports_1 from '@/assets.app/images/kindle-settings-mobile.png'


import { useTemplateRef } from 'vue'
import BasePopup from '@/components/ui/BasePopup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'KindleScreenshotPopup',
  setup(__props, { expose: __expose }) {

const popup = useTemplateRef('popup')

function show(): void {
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: "Kindle settings integration"
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "book-export__image-wrapper" }, [
        _createElementVNode("img", {
          class: "book-export__settings-screenshot",
          src: _imports_0
        })
      ], -1),
      _createElementVNode("div", { class: "book-export__image-wrapper" }, [
        _createElementVNode("img", {
          class: "book-export__settings-screenshot-mobile",
          src: _imports_1
        })
      ], -1)
    ]))]),
    _: 1
  }, 512))
}
}

})